import React from 'react';
import { urlWebsite } from '../../../../../../../config';
import { ParagraphStyle } from '../../ContentItem/styles';
import { EditableDiv } from 'src/pages/DashboardPages/features/PageCreator2/styles';
import { useModal } from 'src/hooks/Modal';

interface IProps {
    list: Record<string, any>;
    computer: Record<string, any>;
    mobile: Record<string, any>;
}


const DataLine = ({ item, computer, mobile }: any) => {

    const { addModal } = useModal();


    return <EditableDiv computer={computer} mobile={mobile} >

        {item?.contents?.map((content: any) => {

            return <> {
                content?.text ? <ParagraphStyle
                    computer={{ "text-align": content?.computer_text_align || computer?.[`text-align`] || 'center', color: content?.computer_color || computer?.color || '#fff', "font-size": content?.computer_font_size || computer?.[`font-size`] || '14px', "line-height": content?.computer_font_height || computer?.[`line-height`] || '18px' }}
                    mobile={{ "text-align": content?.mobile_text_align || mobile?.[`text-align`] || computer?.[`text-align`] || 'center', color: content?.mobile_color || mobile?.color || computer?.color || '#fff', "font-size": content?.mobile_font_size || mobile?.[`font-size`] || computer?.[`font-size`] || '14px', "line-height": content?.mobile_font_height || mobile?.[`line-height`] || computer?.[`line-height`] || '18px' }}
                    dangerouslySetInnerHTML={{ __html: content?.text }}

                /> : <></>
            }
                {content?.image ? <img src={`${urlWebsite}/${content?.image}`} style={{ width: content?.image_size || '30px' }} /> : <></>}

            </>
        })}

    </EditableDiv>

}

const DataListContent: React.FC<IProps> = ({ list, computer, mobile }) => {

    return (<>{
        list?.map(group => {

            return <div style={{ flexWrap: 'wrap' }} className={`gap-sm full-width ${group?.direction || 'row-to-column'}`}>
                {group?.content?.map(item => <DataLine item={item} computer={computer} mobile={mobile} />)}

            </div>

        })
    }

    </>);
};
export default DataListContent;
